export interface HeroScreenshotProps
  extends Omit<
    React.HTMLAttributes<HTMLImageElement>,
    "src" | "alt" | "style"
  > {
  src: string;
  alt: string;
  style: React.HTMLAttributes<HTMLImageElement>["style"];
}

/**
 * A screenshot to show in the hero section of the home page.
 */
export function HeroScreenshot({
  src,
  alt,
  style,
  ...rest
}: HeroScreenshotProps) {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: 300,
        filter: "drop-shadow(0px 0px 2px #222)",
        ...style,
      }}
      {...rest}
    />
  );
}
